<template>
  <table class="publication-table uk-margin-remove-top uk-table uk-table-divider uk-table-justify">
    <thead>
      <tr>
        <th>{{ $t('fields.tenant') }}</th>
        <th>{{ $t('fields.list') }}?</th>
        <th v-if="showActions"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(publication, index) in publications">
        <td>
          <router-link
            v-if="isAuthenticatedAsAdmin"
            :to="{ name: 'tenant', params: { id: publication.tenant.id } }"
          >
            {{publication.tenant.name}}
          </router-link>
          <span v-else>{{publication.tenant.name}}</span>
        </td>
        <td>
          <yes :value="publication.list" />
          <span v-if="publication.position === 1">
            ({{$t('positionModes.top')}})
          </span>
          <span v-else-if="publication.position === -1">
            ({{$t('positionModes.bottom')}})
          </span>
          <span v-else-if="publication.position !== null">
            ({{$t('positionInfo', { position: publication.position })}})
          </span>
        </td>
        <td v-if="showActions">
          <data-grid-actions
            @edit="onEditItem(index)"
            @remove="onRemoveItem(index)"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import UIkit from 'uikit';
import { mapGetters } from 'vuex';
import DataGridActions from '@/components/DataGridActions';
import Yes from '@/components/Yes';

export default {
  name: 'publication-table',
  components: {
    DataGridActions,
    Yes,
  },
  props: {
    publications: {
      type: Array,
      required: true,
    },
    showActions: Boolean,
  },
  computed: mapGetters(['isAuthenticatedAsAdmin']),
  methods: {
    onEditItem(index) {
      this.$emit('edit', index);
    },
    onRemoveItem(index) {
      UIkit.modal
           .confirm(this.$t('confirmations.removePublication'))
           .then(() => { this.$emit('remove', index); })
           .catch(() => {});
    },
  },
  i18n: {
    messages: {
      de: {
        confirmations: {
          removePublication: 'Die Veröffentlichung wirklich entfernen?',
        },
        positionInfo: 'an Position {position}',
        positionModes: {
          top: 'am Listenanfang',
          bottom: 'am Listenende',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// PublicationTable.vue?667e952e